import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Navigation } from "@/components/Navigation";
import { Campaign } from "@/components/Campaign";
import { Objectives } from "@/components/Objectives";
import { Clubs } from "@/components/Clubs";
import { Services } from "@/components/Services";
import { Transformations } from "@/components/Transformations";
import { PersonalTraining } from "@/components/PersonalTraining";
import { Gallery } from "@/components/Gallery";
import { LeadForm } from "@/components/LeadForm";
import { Testimonials } from "@/components/Testimonials";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: isLoaded ? 1 : 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-[#F5F3EF]"
    >
      <Navigation />
      <WhatsAppButton />
      <main>
        {/* Campaign comes first - right after navigation */}
        <Campaign />
        <Objectives />
        <Clubs />
        <Transformations />
        <Services />
        <PersonalTraining />
        <Testimonials />
        <Gallery />
        <LeadForm />
      </main>
      <Footer />
    </motion.div>
  );
}
